import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('syncManagementStore', Object.keys(state)),
	...mapGetters('syncManagementStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('syncManagementStore', Object.keys(actions)),
	...mapMutations('syncManagementStore', Object.keys(mutations))
};
